import { requestGet, requestPost, requestPut, requestDelete } from '../request'
import apiPath from './apiPath'

const api = {
  CreateItem(payload) {
    return requestPost(apiPath.ITEM.path, payload)
  },

  GetOneItem(itemID) {
    return requestGet(`${apiPath.ITEM.path}/${itemID}`)
  },

  GetAllItem(paging, sorting, filtering) {
    return requestGet(apiPath.ITEM.path, {
      page: paging.page,
      size: paging.size,
      sortBy: sorting.byField,
      sortDir: sorting.isDesc ? 'asc' : 'desc',
      f_itemCode: filtering.itemCode,
      f_itemDescription: filtering.itemDescription
    })
  },

  UpdateItem(itemID, payload) {
    return requestPut(`${apiPath.ITEM.path}/${itemID}`, payload)
  },

  DeleteItem(itemID) {
    return requestDelete(`${apiPath.ITEM.path}/${itemID}`)
  }
}

export default api
